import { configure } from '@formwerk/core'

// Forms already validate via Zod schemas (see `useForm({ schema })`), so formwerk's
// native HTML5 constraint validation is redundant. It also runs an onMounted
// revalidation that can't run during SSR, which caused aria-invalid/aria-errormessage
// to flip right after hydration and triggered a Vue hydration mismatch warning.
export default defineNuxtPlugin(() => {
  configure({ disableHtmlValidation: true })
})
